/* index.tsx */

import { fetchWithToken } from "../interceptor";

export async function loginUser(app_id: string, user_id: string, mail: string) {
    try {
        await fetchWithToken(`/v1/users/login/${app_id}/${user_id}/${mail}`);
        return true; // éxito
    } catch (error) {
        throw error; // lanza el error para que React pueda manejarlo
    }
}

/**
 * Logs out the user by calling the logout API and clearing the session storage.
 *
 * @param app_id - The application ID.
 * @param user_id - The user ID.
 * @returns void
 */
export function logoutUser(app_id: string, user_id: string): void{
    ( async(app_id: string, user_id: string) => {
        await fetchWithToken(`/v1/users/logout/${app_id}/${user_id}`);
        sessionStorage.clear();
    })(app_id, user_id);
}

